import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
//window.moment = require('moment');
window.moment = require('moment-timezone');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentEmail: null,
    user: JSON.parse(localStorage.getItem('user')),
    projects: [],
    userData: JSON.parse(localStorage.getItem('user-data')),
    isTest: !!localStorage.getItem('is-test')
  },
  getters: {
    isLoggedIn(state) {
      return !!state.user;
    },
    projects(state) {
      return state.projects;
    },
    userData(state) {
      return state.userData;
    },
    isBaseActionsGranted(state) {
      if (!state.userData) {
        return false;
      }
      return state.userData.roles.includes('ROLE_SUPER_ADMIN');
    },
    isWalletAccessGranted(state) {
      if (!state.userData) {
        return false;
      }
      return state.userData.roles.includes('ROLE_APP');
    }
  },
  mutations: {
    changeCurrentEmail(state, email) {
      state.currentEmail = email;
    },
    login(state, user) {
      state.user = user;
    },
    logout(state) {
      state.user = null;
    },
    setProjects(state, projects) {
      let projectsFormated = [];
      for (let project of projects) {
        projectsFormated.push({value: project.id, text: project.title})
      }
      state.projects = projectsFormated;
    },
    setUserData(state, data) {
      state.userData = data;
    },
    changeTestData(state) {
      state.isTest = !state.isTest;
      if (state.isTest) {
        localStorage.setItem('is-test', true);
      } else {
        localStorage.removeItem('is-test');
      }
    }
  },
  actions: {
    login(context, data) {
      return new Promise((resolve, reject) => {
        context.commit('logout');
        window.axios.post(process.env.VUE_APP_TOKEN_URL, qs.stringify({
          grant_type: 'password',
          username: data.username,
          password: data.password,
          client_id: 'app',
          client_secret: '',
          access_type: 'offline',
        }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
            .then(response => {
              const user = response.data;
              localStorage.setItem('user', JSON.stringify(user));
              window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
              context.commit('login', user);
              context.dispatch('getUserData');
              resolve(user)
            })
            .catch(error => {
              context.commit('logout');
              localStorage.removeItem('user');
              localStorage.removeItem('user-data');
              localStorage.removeItem('is-test');
              reject(error)
            })
      })
    },
    logout(context) {
      return new Promise((resolve) => {
        context.commit('logout');
        localStorage.removeItem('user');
        localStorage.removeItem('user-data');
        localStorage.removeItem('is-test');
        delete window.axios.defaults.headers.common['Authorization'];
        resolve()
      });
    },
    refresh(context) {
      return new Promise((resolve, reject) => {
        if (context.state.user) {
          delete window.axios.defaults.headers.common['Authorization'];
          return window.axios.post(process.env.VUE_APP_TOKEN_URL, qs.stringify({
            grant_type: 'refresh_token',
            refresh_token: context.state.user.refresh_token,
            client_id: 'app',
            client_secret: '',
          }), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          })
              .then(response => {
                const user = response.data;
                localStorage.setItem('user', JSON.stringify(user));
                window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
                context.commit('login', user);
                resolve(response)
              })
              .catch(error => {
                context.dispatch('logout');
                reject(error)
              })
        }
        resolve()
      });
    },
    getProjectsList(context) {
      if (context.state.projects.length > 0) {
        return;
      }
      window.axios.get('/admin/static/projects')
          .then(response => {
                context.commit('setProjects', response.data)
              }
          );
    },
    getUserData(context) {
      window.axios.get('/admin/user')
          .then(response => {
                localStorage.setItem('user-data', JSON.stringify(response.data));
                context.commit('setUserData', response.data)
              }
          );
    },
    changeTestData(context) {
      context.commit('changeTestData');
    }
  },
  modules: {
  }
})
